var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"fluid":""}},[_c('v-row',{staticClass:"pa-2"},[_c('v-col',[_c('v-sheet',[_c('v-col',[_c('user-container')],1)],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }